module.exports = __webpack_public_path__ + "img/e1.d2a1f87e.png";